import { Global, Jobs, JobsCategory } from '@sourceflow-uk/sourceflow-sdk';
import "@sourceflow-uk/job-search/dist/bundle.css";
import SeoHead from '../../components/SeoHead';
import Newsletter from '../../components/Newsletter';
import JobDetails from '../../components/JobDetails';
import MainBanner from '../../components/MainBanner';
import GoogleJobSchema from "../../components/GoogleJsonData";

export default function JobsPage({
  global,
  page,
  similar_jobs,
  job_type,
}) {
  return (
    <>
      <SeoHead
        page_name={`${page.title} in ${page.location} | Lorien`}
        description={`Apply for ${page.title} in ${page.location} with Lorien, specialists in Technology.`}
        canonical_link={`jobs/${page.url_slug}`}
        removeUSHrefLang={true}
      />
      <MainBanner
        global={global}
        pathPrefix={`job_page.main_banner`}
        customClass={``}
        content={``}
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/job-banner-overlay.png`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
      />
      <JobDetails
        global={global}
        pathPrefix={`job_page.job_details`}
        customClass={`position-relative mb-5`}
        post={page}
        buttonTitle={`Back to jobs page`}
        buttonLink={`/jobs/`}
        job={page}
        job_type={job_type}
        jobId={`${page.id}`}
        successPageUrl={`/jobs/thank-you-for-applying/`}
        content={
          <>
            <h2>Apply to this Job</h2>
          </>
        }
        share_job_content={
          <p><strong>Share this Job</strong></p>
        }
        similar_jobs={similar_jobs}
      />
      <Newsletter
        global={global}
        pathPrefix={`job_page.newsletter`}
        customClass={`py-5 blueGradientBg newsletter uk-dynamic-forms`}
        content={
          <>
            <h2>More Informations</h2>
          </>
        }
        content_2={
          <>
            <h2>Subscribe to our newsletter</h2>
            <p>With insight across the whole of Lorien, we'll keep you ahead of the curve on the talent market.</p>
          </>
        }
        formId={`308d12ba-6cc4-44a5-91e2-76d1d714bf23`}
        successPageUrl={`/submission-success`}
        buttonTitle={`Insights`}
        buttonLink={`/insights/`}
        buttonTitle2={``}
        buttonLink2={``}
      />
      <GoogleJobSchema
        job={page}
        job_type={job_type}
        job_currency={`GBP`}
        job_payment_type={`YEAR`}
        job_country={`United Kingdom`}
        site_name={`Lorien`}
        site_domain_link={`https://www.lorienglobal.com/`}
        site_google_logo_link={`https://www.lorienglobal.com/site-assets/images/google-image-v2.jpg`}
        site_domain_jobs_link={`https://www.lorienglobal.com/jobs`}
      />
    </>
  )
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const page = (await Jobs()).getJsonItem(params.slug, 'url_slug');

  const currentjob = await Jobs();
  const internalcategory = currentjob.getItems().find(j => j.url_slug === params.slug);

  // Checks sector category
  const getIndexedValues = async function (categoryName) {
    const category = await JobsCategory(categoryName)
    return [category, category.items.reduce((previous, value) => ({ [value.id]: value, ...previous }), {})]
  }
  const jobTypeCategory = await getIndexedValues('job_types');

  const jobTypeSectorIds = internalcategory.categories.find((cat) => cat.id === jobTypeCategory[0].id)?.values || []

  const jobType = jobTypeSectorIds.map((jobtype, index) => jobTypeCategory[1][jobtype.id] ? jobTypeCategory[1][jobtype.id].title?.en + `${jobTypeCategory.length > 1 ? `${index === jobTypeSectorIds.length - 1 ? "" : ", "}` : ""}` || null : null);

  // Get similar jobs
  let similar_jobs;

  similar_jobs = (await Jobs())
    .getItems()
    .filter(function (job) {
      return (
          job.categories
          .find((cat) => cat.id === "7710db30-b4cf-4029-b846-e02e2f0c9b3b")
          ?.values?.map((v) => v.name).includes("United Kingdom")
      );
  })
    .filter(function (job) {
      return new Date(job?.expires_at) >= new Date();
    })
    .slice(0, 3);

  return {
    props: {
      global,
      page,
      similar_jobs,
      job_type: jobType,
    }
  };
}

export async function getStaticPaths() {
  const jobs = await Jobs()

  const jobsSlugs = jobs.filter(function (job) {
    return (
      job.categories
        // Pulls Sectors only
        .find((cat) => cat.id === "7710db30-b4cf-4029-b846-e02e2f0c9b3b" && cat.values.map((x) => x.id).includes("73aeaf93-9fd9-4947-bfd8-4ce08ce31d01"))
    );
  }).map('url_slug').getItems()

  const paths = jobsSlugs.map((jobSlug) => ({
    params: { slug: jobSlug },
  }))
  return { paths, fallback: false }
}
